import { ModalProvider } from "@commonlibs";
import { Suspense } from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { default as config } from "common/config/config";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { useLoad } from "../common/hooks/useLoad";
import { useAuthRoutes } from "ui/auth/router/AuthRouter";
import { useMainRoutes } from "ui/common/router/MainRouter";
import { usePaymentGatewayRoutes } from "ui/payment-gateway/router/PaymentGatewayRouter";
import LoadingPage from "ui/common/pages/LoadingPage/LoadingPage";
import NotFoundPage from "ui/common/pages/NotFoundPage/NotFoundPage";

const Routes = () => {
    const authRoutes = useAuthRoutes();
    const mainRoutes = useMainRoutes();
    const paymentGatewayRoutes = usePaymentGatewayRoutes();

    return useRoutes([...authRoutes, ...mainRoutes, ...paymentGatewayRoutes, { path: "*", element: <NotFoundPage /> }]);
};

const Router = (): JSX.Element => {
    const loading = useLoad();

    return (
        <BrowserRouter basename={config.publicUrl}>
            <ModalProvider>
                <ScrollToTop />
                <Suspense fallback={<LoadingPage />}>{loading ? <LoadingPage /> : <Routes />}</Suspense>
            </ModalProvider>
        </BrowserRouter>
    );
};

export default Router;
